// Auto-mapping from a structure suggestion's role hints.
// Only fields that are still unmapped are filled in.

const mapLevel = (fields = [], roles = {}, current = {}) => {
    const map = { ...current };
    const mapped = [];
    for (const field of fields) {
        if (map[field.key] || !field.role || !roles[field.role]) continue;
        map[field.key] = roles[field.role];
        mapped.push(field.key);
    }
    return { map, mapped };
};

/**
 * Applies a suggestion's role hints to a source.
 *
 * @returns {{ source: object, mapped: string[] }} the updated source and the
 *   fields that were mapped, as "product.<key>" / "variant.<key>"
 */
export const autoMapSource = (source, model, suggestion) => {
    const product = mapLevel(model?.product_fields, suggestion?.roles?.product, source.product_map);
    const variant = mapLevel(model?.variant_fields, suggestion?.roles?.variant, source.variant_map);
    const mapped = [...product.mapped.map((k) => `product.${k}`), ...variant.mapped.map((k) => `variant.${k}`)];

    // Keyed maps use the member name as the product id.
    const productKey = model?.product_fields?.find((f) => f.role === "key")?.key;
    if (suggestion?.keyed && productKey && !source.product_map?.[productKey]) {
        product.map[productKey] = { ref: "$key" };
        mapped.push(`product.${productKey}`);
    }
    return { source: { ...source, product_map: product.map, variant_map: variant.map }, mapped };
};

export const describeAutoMap = (mapped) =>
    mapped.length
        ? `Auto-mapped ${mapped.length} field${mapped.length === 1 ? "" : "s"}: ${mapped.join(", ")}.`
        : "Auto-map found nothing new: every field with a matching role is already mapped. Fields without a role (e.g. colour) need mapping by hand.";

// Key order can change when a config is edited and saved, so compare canonically.
const canonical = (value) => {
    if (Array.isArray(value)) return value.map(canonical);
    if (value && typeof value === "object") {
        return Object.keys(value).sort().reduce((out, key) => {
            if (value[key] !== undefined) out[key] = canonical(value[key]);
            return out;
        }, {});
    }
    return value;
};

export const sameExtract = (a, b) => JSON.stringify(canonical(a || {})) === JSON.stringify(canonical(b || {}));
